/**
 * App Version Management
 * Version is automatically generated at build time using timestamp
 * 
 * Production builds: timestamp-based (e.g., 1729512345678)
 * Development builds: static 'dev' version
 */

// Auto-generated version using build timestamp
// This ensures every production build gets a unique version, forcing cache clear
// FAIL LOUDLY if build value is missing
if (!process.env.BUILD_VERSION) {
  const error = "❌ FATAL: BUILD_VERSION not set by webpack build process. Check webpack.config.js DefinePlugin configuration.";
  console.error(error);
  throw new Error(error);
}
export const APP_VERSION = process.env.BUILD_VERSION;

// Build timestamp (ISO format for reference)
// FAIL LOUDLY if build value is missing
if (!process.env.BUILD_TIMESTAMP) {
  const error = "❌ FATAL: BUILD_TIMESTAMP not set by webpack build process. Check webpack.config.js DefinePlugin configuration.";
  console.error(error);
  throw new Error(error);
}
export const BUILD_TIMESTAMP = process.env.BUILD_TIMESTAMP;

// Human-readable version (manually update for major releases)
export const RELEASE_VERSION = "1.0.4";

/**
 * Get a human-readable version display
 * @returns {string} Formatted version string
 */
export const getVersionDisplay = () => {
  if (APP_VERSION === "dev") {
    return `v${RELEASE_VERSION} (Development)`;
  }
  
  // If APP_VERSION is a timestamp, show it with the build date
  if (!isNaN(APP_VERSION) && APP_VERSION.length > 10) {
    const buildDate = new Date(parseInt(APP_VERSION));
    return `v${RELEASE_VERSION} (Build: ${buildDate.toLocaleString()})`;
  }
  
  return `v${APP_VERSION}`;
};

/**
 * Check if this is a development build
 * @returns {boolean}
 */
export const isDevelopmentBuild = () => {
  return APP_VERSION === "dev" || process.env.NODE_ENV === "development";
};

// Changelog (update manually for major releases)
// 1.0.4 - Improved cache clearing with force reload and Firebase auth preservation
// 1.0.3 - Version now visible in production, camera improvements, UI refinements
// 1.0.2 - Added version display for development
// 1.0.1 - Fixed mobile data loading issue, reduced Firebase API cache time
// 1.0.0 - Initial release
